import React from 'react';
import templates from '../templates';
import { promoPropTypes } from '../utilities/commonPropTypes';
import '../global-sass/index.scss';
import { isMobile4x3 } from '../utilities/aspect';
import { aR } from '../global-constants';
import { useURLPrefs } from '../hooks/useURLPrefs';

const VehiclePromo = ({
	aspectRatio,
	ctaLabel,
	ctaUrl,
	description = '',
	id,
	imageUrl = '',
	isMobile,
	isVisible = true,
	promo,
	title,
	type,
	vehicleImages = [],
	width,
	carouselPosition
}) => {
	const { collection } = useURLPrefs();
	const ctaButtonData = { ctaUrl, ctaLabel };
	const detailsButtonData = { id, type };
	const isMobile4x3Template = isMobile4x3(aspectRatio);
	const updatedAR = isMobile4x3Template ? aR.MOBILE_4X3 : aspectRatio;

	const Template = templates[collection][updatedAR];

	if (Template) {
		return (
			<Template
				ctaButtonData={ctaButtonData}
				description={description}
				detailsButtonData={detailsButtonData}
				imageUrl={imageUrl}
				isMobile={isMobile}
				isVisible={isVisible}
				promo={promo}
				title={title}
				type={type}
				vehicleImages={vehicleImages}
				width={width}
				carouselPosition={carouselPosition}
			/>
		);
	} else {
		return null;
	}
};

VehiclePromo.propTypes = promoPropTypes;

export default VehiclePromo;
